import React from 'react';
import SvgIcon from './SvgIcon';

function KeyIcon({ width }) {
    return (
        <SvgIcon className="KeyIcon" width={width}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 18 18"
            >
                <path
                    fill="#fff"
                    d="M5.25 10.211c-.336 0-.621-.118-.857-.354A1.168 1.168 0 014.039 9c0-.336.118-.621.354-.857s.521-.354.857-.354c.336 0 .621.118.857.354s.354.521.354.857c0 .336-.118.621-.354.857a1.168 1.168 0 01-.857.354zm0 2.914c-1.144 0-2.118-.401-2.92-1.204-.804-.803-1.205-1.777-1.205-2.921s.401-2.118 1.204-2.92c.803-.804 1.777-1.205 2.921-1.205.804 0 1.53.207 2.18.622.65.415 1.147.958 1.49 1.628h6.75L17.547 9l-2.885 2.87-1.392-1.045-1.428 1.06-1.464-1.01H8.92a4.173 4.173 0 01-1.488 1.624 3.95 3.95 0 01-2.181.626zm0-1.125c.72 0 1.342-.217 1.868-.652A2.99 2.99 0 008.15 9.75h2.582l1.08.747 1.466-1.072 1.273.974L15.95 9l-.75-.75H8.15a2.99 2.99 0 00-1.032-1.598C6.592 6.217 5.97 6 5.25 6c-.825 0-1.531.294-2.119.881A2.889 2.889 0 002.25 9c0 .825.294 1.531.881 2.119A2.889 2.889 0 005.25 12z"
                />
            </svg>
        </SvgIcon>
    );
}

export default KeyIcon;
